import React from 'react';
import '../styles/css/app.css';
import Form from './Form'
import PropTypes from 'prop-types';

import * as actions from '../actions/formActions';
import {bindActionCreators} from 'redux';

import {connect} from 'react-redux';

const App = ({actions, success,ajaxCallInProgress}) => {

    return (
        <div className="App">

            {success === 0 ?
                <Form onSubmit={actions.sendForm} ajaxCallInProgress={ajaxCallInProgress}/> :
                <div className="success-container">
                    <div className="thanks">Gracias!</div>
                    <div className="message"></div>
                </div>}
        </div>
    );
}

App.propTypes = {
    actions: PropTypes.object.isRequired,
    success: PropTypes.number.isRequired,
    ajaxCallInProgress: PropTypes.number.isRequired,
}

function mapStateToProps(state, ownProps) {
    return {
        success: state.success,
        ajaxCallInProgress:state.ajaxCallInProgress,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),

    };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js